import { SectionTitleAndSubtitle } from "@/components/SectionTitleAndSubtitle";
import { Container } from "@mui/material";
import { CountUpSection } from "../CountUpSection";

export function MetricSection() {
  return (
    <Container
      sx={{
        paddingY: {
          xs: "50px",
          md: "70px",
        },
        display: "flex",
        flexDirection: "column",
        gap: {
          xs: 3,
          sm: 5,
        },
      }}
    >
      <SectionTitleAndSubtitle
        title="Nossos Resultados"
        subTitle="Desde 2023 no mercado levando segurança e economia tributária para empresas de todo o Brasil."
      />

      <CountUpSection />
    </Container>
  );
}
